import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var RenderingMode = /** @class */ (function (_super) {
    __extends(RenderingMode, _super);
    function RenderingMode() {
        return _super.call(this) || this;
    }
    RenderingMode.forceNativeConstructor = true;
    RenderingMode.forceNativeMethods = true;
    // JS -> AS Bindings
    RenderingMode.NORMAL = 'normal';
    RenderingMode.CFF = 'cff';
    return RenderingMode;
}(ASObject));
export { RenderingMode };
